exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:900px){.maxWidth[data-v-1122e722]{width:100%}}", ""]);

// exports
